module.exports = __webpack_public_path__ + "assets/img/f327-ca.svg";